import React, { useEffect, useState } from 'react';
// import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';

import clsx from 'clsx';
import jwt from 'jsonwebtoken';
import { Grid, Hidden, makeStyles, useMediaQuery } from '@material-ui/core';

import { getUserRoleId, hasPermission } from '../Utils/helper';
// import MechanicDashBoard from '../MechanicComp';
import Onboarding from '../Onboarding/Onboarding';
import JobCard from './Components/JobCard/JobCard';
import Revenue from './Components/Revenue/Revenue';
import { useSharedState } from '../../StoreContext';
import Invoices from './Components/Invoices/Invoices';
import Calendar from './Components/Calendar/Calendar';
import {
  getUser,
  getGamificationDetails,
} from '../../actions/users/co-user-actions';
import { getCurrencySymbol } from '../../utils/getCurrencySymbol';
import { geAllRoCards } from '../../actions/repairOrder/ro-actions';
import { getInvoices } from '../../actions/invoice/invoice-actions';
import { getPayments } from '../../actions/payments/payments-action';
import { getUserDetails } from '../../actions/dashboardOwner/dashboard-owner';
import PaymentWarningPopup from '../SettingsComp/components/subscription/BlockAccount/PaymentWarningPopup';
import { getSubscription } from '../../actions/subscription/subscription-actions';
import IconsMobile from '../../pages/Dashboard/Components/IconsMobile/IconsMobile';
// import GamificationPopup from '../Gamification/GamificationPopup';
import { Toast } from '../Toast/Toast';

const useStyles = makeStyles((theme) => ({
  main__grid: {
    padding: '1.5rem .5rem 1.5rem 0',
    height: 'calc(100vh - 110px)',
    overflowY: 'auto',
  },
  padding__left: {
    paddingLeft: '0.75rem',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: '0',
    },
  },
  padding__right: {
    paddingRight: '0.75rem',
    [theme.breakpoints.down('sm')]: {
      paddingRight: '0',
    },
  },
  padding__top: {
    paddingTop: '1.5rem',
  },
  calendar__height: {
    height: '690px',
    minWidth: '30%',
    [theme.breakpoints.down('md')]: {
      height: '824px',
      minWidth: '40%',
    },
    [theme.breakpoints.down('sm')]: {
      minWidth: '100%',
      paddingTop: '1.5rem',
    },
  },
  left__content__width: {
    maxWidth: '70%',
    [theme.breakpoints.down('md')]: {
      maxWidth: '60%',
    },
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%',
    },
  },
  second__child: {
    [theme.breakpoints.down('md')]: {
      paddingLeft: '0',
      paddingTop: '1.5rem',
    },
  },
}));

export default function index() {
  const classes = useStyles();
  const [roleId, setRoleId] = useState(null);
  const [onboardingToggle, setOnboardingToggle] = useState(false);
  const [openPaymentWarningPopup, setOpenPaymentWarningPopup] = useState(false);
  // const [tutorial, setTutorial] = useState(false);

  const dispatch = useDispatch();
  const { estimateData } = useSelector((state) => state.estimate);
  const [currency, setCurrency] = useState('$');
  const { jobCardData } = useSelector((state) => state.jobCard);
  // const { getGamifications } = useSelector((st) => st.coUser);
  const { data } = useSelector((state) => state.getDashboard.userDetails || {});
  const { wizardData: { data: wizardData = {} } = {} } = useSelector(
    (state) => state.wizard,
  );

  const toggleSettings = useSelector(
    (st) => st?.settings?.toggleSettings || '',
  );

  const trialInfo = useSelector((s) => s.subscription?.trialInfo || '');

  const { payInvoiceSuccess = '', payInvoiceError = '' } = useSelector(
    (state) => state.subscription,
  );

  const [totalRevenuePermission, setTotalRevenuePermission] = useState(true);
  const [unpaidInvoiceWidgetPermission, setUnpaidInvoiceWidgetPermission] =
    useState(true);
  const [upcominAppointmentsPermission, setUpcominAppointmentsPermission] =
    useState(true);
  const [jobBoardPermission, setJobBoardPermission] = useState(true);

  const [stripePromise, setStripePromise] = useState(null);

  useEffect(async () => {
    setStripePromise(loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY));
    dispatch(getGamificationDetails());
    // ======== ip testing =========
    // try {
    //   const ipData = await axios.get('http://ip-api.com/json');
    //   console.log('>>>>>>>>ipData', ipData?.data);
    // } catch (error) {
    //   console.error('>>>>>>>> error', error);
    // }
    // ========== end ip testing ========
  }, []);

  useEffect(() => {
    const totalRevenuePermis = hasPermission('dashboard', 'Total Revenue');
    const unpaidInvoiceWidgetPermis = hasPermission(
      'dashboard',
      'Unpaid Invoice Widget',
    );
    const upcominAppointmentsPermis = hasPermission(
      'dashboard',
      'Upcoming Appointments',
    );
    const jobBoardPermis = hasPermission('dashboard', 'Job Board');

    if (totalRevenuePermis !== 'owner') {
      setTotalRevenuePermission(totalRevenuePermis);
      setUnpaidInvoiceWidgetPermission(unpaidInvoiceWidgetPermis);
      setUpcominAppointmentsPermission(upcominAppointmentsPermis);
      setJobBoardPermission(jobBoardPermis);
    }
  }, []);

  // set tutorial true
  // useEffect(() => {
  //   if (
  //     data?.userStore && // if user on boarded then useStore will not empty
  //     !openPaymentWarningPopup && // if popup is not open
  //     getGamifications?.gamification &&
  //     !getGamifications?.gamification?.skip &&
  //     !getGamifications?.gamification?.dontShowAgain
  //   ) {
  //     setTutorial(true);
  //     dispatch({ type: 'CLEAR_GAMIFICATION_STATE' });
  //   }
  // }, [getGamifications, data?.userStore]);

  // success or error case of pay invoice ( from payment lock screen)
  useEffect(() => {
    let check = '';
    let message = '';
    if (payInvoiceSuccess) {
      check = 'success';
      message = payInvoiceSuccess;
    } else if (payInvoiceError) {
      check = 'error';
      message =
        payInvoiceError || 'Some error has been occurred, Please try again.';
    }

    if (check) {
      Toast(check, message);

      dispatch({ type: 'CLEAR_PAY_INVOICE_STATES' });
    }
  }, [payInvoiceSuccess, payInvoiceError]);

  // const dispatchAction = useContext(DispatchContext);
  const [, dispatchAction] = useSharedState();

  let userData = localStorage.getItem('userData') || '';
  userData = userData ? JSON.parse(userData) : '';
  // const userStore = userData?.userStore || '';
  // const generalInfo = userStore?.generalInfo || '';
  const { token } = userData;
  let jwtDecodeToken;
  if (token) {
    jwtDecodeToken = jwt.decode(token);
  }

  const headerData = {
    title: 'Dashboard',
    link: null,
    id: '',
    businessName: '',
    address: '',
  };

  const clearStates = () => {
    // clearing the context states

    dispatchAction({
      type: 'clearItems',
      payload: {},
    });

    // clearing the inspection add reducer states

    dispatch({ type: 'CLEAR_ADD_INSPECTION_STATES', payload: {} });
  };

  // if userstore not exist then onboarding popup will appear
  useEffect(() => {
    if (
      !userData?.userStore &&
      jwtDecodeToken &&
      jwtDecodeToken?.roleId === 4
    ) {
      if (!onboardingToggle) {
        // setting up stripe promise for stripe payment form

        setOnboardingToggle(true);
      }
    } else if (wizardData?.userId) {
      setOnboardingToggle(false);

      // after successfull onboarding call get subscription api
      dispatch(getSubscription());

      dispatch({ type: 'CLEAR_USER_WIZARD_STATE' });
    }
  }, [wizardData]);

  // this useEffect will run when onboarding popup is closed
  // if user doesn't set up the business details then get userdetail Api will not call
  useEffect(() => {
    if (!userData?.userStore) return;

    if (!onboardingToggle) {
      dispatch(getUserDetails());
      dispatch(getUser());
      setCurrency(getCurrencySymbol());
      dispatch(getInvoices(true));
      dispatch(getPayments());
      dispatch(geAllRoCards());
    }
  }, [onboardingToggle]);

  useEffect(async () => {
    let role = '';

    if (token) {
      role = jwtDecodeToken?.roleId;

      setRoleId(role);
    }

    dispatchAction({
      type: 'layout',
      payload: { field: 'setHeader', value: headerData },
    });

    clearStates();
  }, []);

  useEffect(() => {
    if (
      trialInfo &&
      !(trialInfo?.status === 'trialing' || trialInfo?.status === 'active') &&
      userData?.userStore
    ) {
      // show all time popup untill user updates the billing details
      setOpenPaymentWarningPopup(true);
    }
  }, [trialInfo]);

  useEffect(() => {
    if (data) {
      const { userStore } = data;

      headerData.businessName = userStore?.businessName;
      headerData.address = userStore?.address;

      dispatchAction({
        type: 'layout',
        payload: { field: 'setHeader', value: headerData },
      });
    }
  }, [data]);

  const matchesMedia = useMediaQuery('(max-width:1200px)');

  const showJobboard =
    getUserRoleId() === 4
      ? toggleSettings?.workInProgress || false
      : jobBoardPermission;

  return (
    <>
      {roleId === 1 ||
      roleId === 2 ||
      roleId === 3 ||
      roleId === 4 ||
      roleId === 5 ? (
        <Grid
          container
          className={classes.main__grid}
          style={{
            height: matchesMedia ? 'fit-content' : 'calc(100vh - 110px)',
          }}
        >
          <Grid item xs={12} md={9} className={classes.left__content__width}>
            <Grid container>
              <Grid
                item
                xs={12}
                md={12}
                lg={7}
                className={clsx(classes.padding__right)}
              >
                {totalRevenuePermission && <Revenue currency={currency} />}
              </Grid>

              <Grid
                item
                xs={12}
                md={12}
                lg={5}
                className={clsx(
                  classes.padding__left,
                  classes.padding__right,
                  classes.second__child,
                )}
              >
                {unpaidInvoiceWidgetPermission && (
                  <Invoices currency={currency} />
                )}
              </Grid>
            </Grid>
            {showJobboard ? (
              <Hidden only={['md']}>
                <Grid container>
                  <Grid
                    item
                    xs={12}
                    className={clsx(
                      classes.padding__top,
                      classes.padding__right,
                    )}
                  >
                    {jobBoardPermission && (
                      <JobCard
                        estimate={estimateData}
                        jobcards={[jobCardData]}
                      />
                    )}
                  </Grid>
                </Grid>
              </Hidden>
            ) : (
              ''
            )}
          </Grid>
          <Grid
            item
            xs={12}
            md={3}
            className={clsx(classes.padding__left, classes.calendar__height)}
          >
            {upcominAppointmentsPermission && (
              <Calendar matchesMedia={matchesMedia} />
            )}
          </Grid>
          {showJobboard ? (
            <Hidden only={['xs', 'sm', 'lg', 'xl']}>
              <Grid item xs={12} className={clsx(classes.padding__top)}>
                {jobBoardPermission && (
                  <JobCard estimate={estimateData} jobcards={[jobCardData]} />
                )}
              </Grid>
            </Hidden>
          ) : (
            ''
          )}
          {/* {tutorial && (
            <GamificationPopup toggle={tutorial} setToggle={setTutorial} />
          )} */}
        </Grid>
      ) : (
        ''
      )}
      {/* // ) : ( // <MechanicDashBoard />
      // )} */}
      {onboardingToggle && (
        <Elements stripe={stripePromise}>
          <Onboarding
            toggle={onboardingToggle}
            setToggle={setOnboardingToggle}
          />
        </Elements>
      )}
      {openPaymentWarningPopup && (
        <PaymentWarningPopup
          stripePromise={stripePromise}
          status={userData?.checkSubscription}
          toggle={openPaymentWarningPopup}
          setToggle={setOpenPaymentWarningPopup}
        />
      )}
      <Hidden only={['md', 'lg', 'xl']}>
        <IconsMobile />
      </Hidden>
    </>
  );
}
